import React from 'react';
import { motion } from 'framer-motion';
export function StatsStrip() {
  const stats = [{
    value: '12M+',
    label: 'Passenger journeys analysed'
  }, {
    value: '3,200',
    label: 'Vehicles equipped'
  }, {
    value: '99.4%',
    label: 'Anonymisation accuracy'
  }, {
    value: '40%',
    label: 'Reduction in data collection costs'
  }];
  return <section className="bg-sure-black w-full py-16 md:py-24 border-y border-white/10" data-id="element-200">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-201">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-202">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-203">
              <div className="text-sure-white text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight" data-id="element-204">
                {stat.value}
              </div>
              <div className="text-sure-gray text-xs md:text-sm uppercase tracking-widest font-light max-w-[200px]" data-id="element-205">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}